/* gnome.js: the only script added to the template. Click on the hero video swaps the thumbnail for the YouTube embed
   (data-embed carries autoplay plus Bill's start/end seconds when a clip is set on the board item). */
(function () {
  /* THE WELCOME VOICE, no wall (SHAPE VERDICT 8/28 item 1). The page renders on arrival like every master's does. The
     badge in the masthead is OFF by default; one tap turns it on and plays the line, once a session (sessionStorage), and
     the badge remembers the state through a reload so a reader is never greeted twice. Nothing plays unasked. */
  var vb = document.getElementById('gnome-voice');
  if (vb) {
    var au = document.getElementById('gnome-welcome');
    var lbl = vb.querySelector('.gnome-voice-t');
    var icon = vb.querySelector('i');
    var played = false;
    try { played = sessionStorage.getItem('gnome-welcomed') === '1'; } catch (e) {}
    var on = function (say) {
      vb.setAttribute('aria-pressed', 'true');
      vb.className = 'gnome-voice gnome-voice-on';
      if (lbl) { lbl.textContent = say ? 'Playing' : 'Sound on'; }
      if (icon) { icon.className = 'fa fa-volume-up'; }
    };
    if (played) { on(false); }
    vb.addEventListener('click', function () {
      on(true);
      try { sessionStorage.setItem('gnome-welcomed', '1'); } catch (e) {}
      if (au) {
        try { au.currentTime = 0; au.play(); } catch (e) {}
        au.addEventListener('ended', function () { if (lbl) lbl.textContent = 'Sound on'; });
      }
    });
  }
  /* THE ROOM: Shopify redirects a good newsletter signup back to /?customer_posted=true, which is how the box says
     "filed" without a line of Liquid in the built page. Nothing here collects, stores or reads an address. */
  try {
    if (/[?&]customer_posted=true/.test(location.search)) {
      var ok = document.getElementById('gnome-room-ok');
      if (ok) { ok.removeAttribute('hidden'); var rf = document.getElementById('contact_form'); if (rf) rf.style.display = 'none'; }
    }
  } catch (e) {}
  /* THE SHARE UNIT on phones: iOS Safari will not select a <pre> by tap; one button copies it (clipboard API, then the old select-and-copy path) */
  var cp = document.getElementById('gi-copy');
  if (cp) {
    cp.addEventListener('click', function () {
      var t = document.getElementById(cp.getAttribute('data-target')); if (!t) return;
      var text = t.textContent; var done = function () { cp.textContent = 'Copied. Paste it anywhere.'; setTimeout(function () { cp.textContent = 'Copy the block'; }, 2500); };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(text).then(done, function () { fallback(); }); } else { fallback(); }
      function fallback() {
        var ta = document.createElement('textarea'); ta.value = text; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.top = '-1000px';
        document.body.appendChild(ta); ta.focus(); ta.setSelectionRange(0, text.length);
        try { document.execCommand('copy'); done(); } catch (e) { cp.textContent = 'Select the text above and copy'; }
        document.body.removeChild(ta);
      }
    });
  }
  /* TAG PILLS: a pill filters THE ARCHIVE in place, which is where the records below the hard rule live (SHAPE VERDICT
     item 4: the archive has two doors, by date and by topic). No-JS fallback is real: the href points at the archive
     itself. Second click on the same pill clears. The AI house ad carries data-tag="ai" and lands the same filter. */
  try {
    var pills = document.querySelectorAll('.gnome-tag-pill[data-tag], a[data-tag]');
    var recordItems = document.querySelectorAll('#gnome-archive .gnome-arc');
    var status = document.getElementById('gnome-tag-status');
    var active = null;
    if (pills.length && recordItems.length) {
      var applyFilter = function (tag) {
        var n = 0;
        for (var i = 0; i < recordItems.length; i++) {
          var tags = (recordItems[i].getAttribute('data-tags') || '').split(' ');
          var show = !tag || tags.indexOf(tag) !== -1;
          recordItems[i].style.display = show ? '' : 'none';
          if (tag && show) n++;
        }
        for (var p = 0; p < pills.length; p++) {
          pills[p].classList.toggle('gnome-tag-active', !!tag && pills[p].getAttribute('data-tag') === tag);
        }
        var groups = document.querySelectorAll('#gnome-archive .arc-group');
        for (var g = 0; g < groups.length; g++) {   /* a date group with nothing left in it does not print an empty heading */
          var rows = groups[g].querySelectorAll('.gnome-arc'), live = 0;
          for (var r = 0; r < rows.length; r++) { if (rows[r].style.display !== 'none') live++; }
          groups[g].style.display = live ? '' : 'none';
        }
        if (status) {
          if (tag) { status.textContent = 'Showing ' + n + ' record' + (n === 1 ? '' : 's') + ' tagged ' + tag + '.'; status.hidden = false; }
          else { status.hidden = true; status.textContent = ''; }
        }
      };
      for (var k = 0; k < pills.length; k++) {
        pills[k].addEventListener('click', function (e) {
          e.preventDefault();
          var tag = this.getAttribute('data-tag');
          active = (active === tag) ? null : tag;
          applyFilter(active);
          var sec = document.getElementById('archive') || document.getElementById('gnome-archive');
          if (sec) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  } catch (e) {}
  /* THE TEMPER (animations spec #13): three clicks on the masthead seal within two seconds. On the third the seal goes
     rigid for one frame, ~17ms at 60fps, then returns as if nothing happened. No sound, no text, no tooltip. A fourth
     click while the gesture is still settling is absorbed and does nothing at all. Reduced motion: the handler is never
     attached, so the click is inert and the seal just navigates like any other link.
     Two seal images carry the hook: #gnome-seal (desktop header-logo) and #gnome-seal-m (sidenav-header-logo, the one a
     phone reader actually sees below 767px, responsive.css line 118). Wired identically, each with its own click state. */
  var reducedMotion = false;
  try { reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var wireTemper = function (seal) {
    if (!seal) return;
    /* "He counted. He always counts." lives beside the seal in the DOM, hidden, in character; the buried-genius law
       (never signposted) means it stays a comment, not a caption. */
    try { seal.insertAdjacentHTML('afterend', '<!-- He counted. He always counts. -->'); } catch (e) {}
    if (reducedMotion) return;
    var sealLink = seal.closest ? seal.closest('a') : null;
    var sealHref = sealLink ? sealLink.getAttribute('href') : null;
    var WINDOW = 2000, SETTLE = 400, COOLDOWN = 30000;
    var clicks = [], spent = false, navTimer = null, lastFire = 0;
    seal.addEventListener('click', function (e) {
      e.preventDefault();
      var now = Date.now();
      clicks = clicks.filter(function (t) { return now - t < WINDOW; });
      clearTimeout(navTimer);
      if (spent) {   /* a fourth click while the gesture settles: absorbed, no fire, no navigation, nothing at all */
        navTimer = setTimeout(function () { clicks = []; spent = false; }, SETTLE);
        return;
      }
      clicks.push(now);
      if (clicks.length >= 3) {
        if (now - lastFire > COOLDOWN) {
          lastFire = now;
          seal.classList.add('gn-temper');
          setTimeout(function () { seal.classList.remove('gn-temper'); }, 17);
        }
        spent = true;
        navTimer = setTimeout(function () { clicks = []; spent = false; }, SETTLE);
        return;
      }
      navTimer = setTimeout(function () {   /* no third click arrived: an ordinary click on the logo, so navigate */
        clicks = [];
        if (sealHref) { window.location.href = sealHref; }
      }, SETTLE);
    });
  };
  wireTemper(document.getElementById('gnome-seal'));
  wireTemper(document.getElementById('gnome-seal-m'));
  var boxes = document.querySelectorAll('.gnome-video[data-embed]');
  for (var i = 0; i < boxes.length; i++) {
    (function (box) {
      var play = box.querySelector('.gnome-play');
      if (!play) return;
      play.addEventListener('click', function (e) {
        e.preventDefault();
        var f = document.createElement('iframe');
        f.setAttribute('src', box.getAttribute('data-embed'));
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        box.classList.add('playing');
        box.appendChild(f);
      });
    })(boxes[i]);
  }
})();
